@if (quoteList && quoteList.length > 1) {
  <p-select
    (onChange)="onQuoteChange($event)"
    [options]="quoteList"
    [(ngModel)]="quote"
    [placeholder]="$safeNavigationMigration(quote?.getDisplayId())"
  >
  </p-select>
}
